import {Service} from '../../../service';

export class IntegratedReportService extends Service {

  static entity = 'app/integrated-report';

  static getVendors(): Promise<any> {
    return this.axios.get(`app/software-vendor`).then(res => res.data);
  }

  static downloadExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

}
